import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TokenImpService } from '../Services/ImplementacionServicios/token-imp';

@Injectable({
  providedIn: 'root'
})
export class LoginEmpleadoGuardGuard implements CanActivate {
  constructor(
    private router: Router,
    private jwtTokenImpService: TokenImpService
  ) {
  }

  canActivate() {
    let isLogin = this.jwtTokenImpService.getbRtaEmpleado();
    if (isLogin) {
      return true;
    } else {
      this.router.navigate(['sesion/loginAdmin']);
      return false;
    }
  }
  
}
